export const ENTER = 13;
export const ESCAPE = 27;
export const K = 75;
export const LEFT = 37;
export const UP = 38;
export const RIGHT = 39;
export const DOWN = 40;
export const BACKSPACE = 8;